<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCSpecs :h2="h2" :h3="h3" :specs="specs" floorplan="floorplan-cincinnatus.png" />
  </div>
</template>

<script>
import FCSpecs from "@/components/patterns/FCSpecs";
export default {
  components: {
    FCSpecs
  },
  mounted() {
    const ref = this.$store.state.menu.cincinnatusClub.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.cincinnatusClub.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.cincinnatusClub.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Cincinnatus Club",
      h3: "Specs",
      specs: [
        {
          icon: "chair.svg",
          text: `<strong>1,100</strong> Seats`
        },
        {
          icon: "club.svg",
          text: `<strong>2</strong> Bars`
        },
        {
          icon: "food.svg",
          text: `<strong>3</strong> Dining Concepts`
        },
        {
          icon: "sqft.svg",
          text: `<strong>10,904</strong> Square Feet`
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-cincinnatus-intro.jpg");
  background-size: cover;
  background-position: center;
}
</style>